import styles from "./styles.module.scss";
import { cn } from "@/lib/utils";
import { Card, CardContent, Stack } from "@altimateai/lego";
import { FilterTagWrapper } from "../../components/tags";
import TimeInfoDisclaimer from "../../components/timeInfoDisclaimer";

interface TableHeadingProps {
  numQueries: number;
  filters: { column_rk?: string[] };
  filterObj: Record<string, string>;
  resetColumnFilter: (rks: string[]) => void;
}

const TableHeading = ({ numQueries, filters, filterObj, resetColumnFilter }: TableHeadingProps) => (
  <Stack direction="row" align="center" className={cn("gap-md", styles.filter_tags)}>
    <div className="al-text-lg al-font-medium al-mr-3">Columns</div>
    <FilterTagWrapper
      applicableFor={undefined}
      filters={{
        columnFilter: {
          filterStr: Object.keys(filterObj),
          label: "Column",
          onclose: removedFilter => {
            if (removedFilter) {
              resetColumnFilter(
                (filters.column_rk ?? []).filter(filter => filter !== filterObj[removedFilter])
              );
            }
          },
        },
      }}
    />
    <div className="spacer" />
    <TimeInfoDisclaimer
      numOfSecondsActive={3}
      textToDisplay={
        <div className={cn(styles.info_text, "al-text-muted al-m-2")}>
          Column accessed for this table in the past 30 days
        </div>
      }
    />
    <Card className={cn("al-mr-3 al-mb-0 no-break", styles.query_count)}>
      <CardContent className="al-pt-4 al-pb-2 al-pl-4 al-pr-4">
        <Stack direction="row" align="center" justify="between">
          <div>Queries: {numQueries}</div>
        </Stack>
      </CardContent>
    </Card>
  </Stack>
);

export default TableHeading;
